import React, { useRef, useLayoutEffect, useState, useCallback } from "react";
import { Hooks } from "@xt/xtbase";
import { ArrowUpTriple, ArrowDownTriple } from "./ArrowChevrons";
import styles from "./index.module.less";

const { useTranslation } = Hooks;

/** @typedef {{ type: 'v', x: number, y1: number, y2: number } | { type: 'h', x1: number, x2: number, y: number }} Segment */

function IconYou() {
  return (
    <svg className={styles.nodeSvg} viewBox="0 0 24 24" fill="none" aria-hidden>
      <circle cx="12" cy="8" r="3.5" stroke="#B9F78A" strokeWidth="1.2" />
      <path
        d="M6.5 20.5v-0.5c0-2.5 2.2-4.5 5.5-4.5s5.5 2 5.5 4.5v0.5"
        stroke="#B9F78A"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** 一级节点 icon（设计稿） */
function IconLevel1() {
  return (
    <svg className={styles.nodeSvg} width="19" height="14" viewBox="0 0 19 14" fill="none" aria-hidden>
      <path
        d="M0 13.3333V11C0 10.5278 0.121528 10.0938 0.364583 9.69792C0.607639 9.30208 0.930556 9 1.33333 8.79167C2.19444 8.36111 3.06944 8.03819 3.95833 7.82292C4.84722 7.60764 5.75 7.5 6.66667 7.5C7.58333 7.5 8.48611 7.60764 9.375 7.82292C10.2639 8.03819 11.1389 8.36111 12 8.79167C12.4028 9 12.7257 9.30208 12.9688 9.69792C13.2118 10.0938 13.3333 10.5278 13.3333 11V13.3333H0ZM15 13.3333V10.8333C15 10.2222 14.8299 9.63542 14.4896 9.07292C14.1493 8.51042 13.6667 8.02778 13.0417 7.625C13.75 7.70833 14.4167 7.85069 15.0417 8.05208C15.6667 8.25347 16.25 8.5 16.7917 8.79167C17.2917 9.06944 17.6736 9.37847 17.9375 9.71875C18.2014 10.059 18.3333 10.4306 18.3333 10.8333V13.3333H15ZM6.66667 6.66667C5.75 6.66667 4.96528 6.34028 4.3125 5.6875C3.65972 5.03472 3.33333 4.25 3.33333 3.33333C3.33333 2.41667 3.65972 1.63194 4.3125 0.979167C4.96528 0.326389 5.75 0 6.66667 0C7.58333 0 8.36806 0.326389 9.02083 0.979167C9.67361 1.63194 10 2.41667 10 3.33333C10 4.25 9.67361 5.03472 9.02083 5.6875C8.36806 6.34028 7.58333 6.66667 6.66667 6.66667ZM15 3.33333C15 4.25 14.6736 5.03472 14.0208 5.6875C13.3681 6.34028 12.5833 6.66667 11.6667 6.66667C11.5139 6.66667 11.3194 6.64931 11.0833 6.61458C10.8472 6.57986 10.6528 6.54167 10.5 6.5C10.875 6.05556 11.1632 5.5625 11.3646 5.02083C11.566 4.47917 11.6667 3.91667 11.6667 3.33333C11.6667 2.75 11.566 2.1875 11.3646 1.64583C11.1632 1.10417 10.875 0.611111 10.5 0.166667C10.6944 0.0972222 10.8889 0.0520833 11.0833 0.03125C11.2778 0.0104167 11.4722 0 11.6667 0C12.5833 0 13.3681 0.326389 14.0208 0.979167C14.6736 1.63194 15 2.41667 15 3.33333ZM1.66667 11.6667H11.6667V11C11.6667 10.8472 11.6285 10.7083 11.5521 10.5833C11.4757 10.4583 11.375 10.3611 11.25 10.2917C10.5 9.91667 9.74306 9.63542 8.97917 9.44792C8.21528 9.26042 7.44444 9.16667 6.66667 9.16667C5.88889 9.16667 5.11806 9.26042 4.35417 9.44792C3.59028 9.63542 2.83333 9.91667 2.08333 10.2917C1.95833 10.3611 1.85764 10.4583 1.78125 10.5833C1.70486 10.7083 1.66667 10.8472 1.66667 11V11.6667ZM6.66667 5C7.125 5 7.51736 4.83681 7.84375 4.51042C8.17014 4.18403 8.33333 3.79167 8.33333 3.33333C8.33333 2.875 8.17014 2.48264 7.84375 2.15625C7.51736 1.82986 7.125 1.66667 6.66667 1.66667C6.20833 1.66667 5.81597 1.82986 5.48958 2.15625C5.16319 2.48264 5 2.875 5 3.33333C5 3.79167 5.16319 4.18403 5.48958 4.51042C5.81597 4.83681 6.20833 5 6.66667 5Z"
        fill="#ADAAAA"
      />
    </svg>
  );
}

/** 二级节点 icon（设计稿） */
function IconLevel2() {
  return (
    <svg className={styles.nodeSvg} width="20" height="10" viewBox="0 0 20 10" fill="none" aria-hidden>
      <path
        d="M0 10V8.6875C0 8.09028 0.305556 7.60417 0.916667 7.22917C1.52778 6.85417 2.33333 6.66667 3.33333 6.66667C3.51389 6.66667 3.6875 6.67014 3.85417 6.67708C4.02083 6.68403 4.18056 6.70139 4.33333 6.72917C4.13889 7.02083 3.99306 7.32639 3.89583 7.64583C3.79861 7.96528 3.75 8.29861 3.75 8.64583V10H0ZM5 10V8.64583C5 8.20139 5.12153 7.79514 5.36458 7.42708C5.60764 7.05903 5.95139 6.73611 6.39583 6.45833C6.84028 6.18056 7.37153 5.97222 7.98958 5.83333C8.60764 5.69444 9.27778 5.625 10 5.625C10.7361 5.625 11.4132 5.69444 12.0312 5.83333C12.6493 5.97222 13.1806 6.18056 13.625 6.45833C14.0694 6.73611 14.4097 7.05903 14.6458 7.42708C14.8819 7.79514 15 8.20139 15 8.64583V10H5ZM16.25 10V8.64583C16.25 8.28472 16.2049 7.94444 16.1146 7.625C16.0243 7.30556 15.8889 7.00694 15.7083 6.72917C15.8611 6.70139 16.0174 6.68403 16.1771 6.67708C16.3368 6.67014 16.5 6.66667 16.6667 6.66667C17.6667 6.66667 18.4722 6.85069 19.0833 7.21875C19.6944 7.58681 20 8.07639 20 8.6875V10H16.25ZM6.77083 8.33333H13.25C13.1111 8.05556 12.7257 7.8125 12.0938 7.60417C11.4618 7.39583 10.7639 7.29167 10 7.29167C9.23611 7.29167 8.53819 7.39583 7.90625 7.60417C7.27431 7.8125 6.89583 8.05556 6.77083 8.33333ZM3.33333 5.83333C2.875 5.83333 2.48264 5.67014 2.15625 5.34375C1.82986 5.01736 1.66667 4.625 1.66667 4.16667C1.66667 3.69444 1.82986 3.29861 2.15625 2.97917C2.48264 2.65972 2.875 2.5 3.33333 2.5C3.80556 2.5 4.20139 2.65972 4.52083 2.97917C4.84028 3.29861 5 3.69444 5 4.16667C5 4.625 4.84028 5.01736 4.52083 5.34375C4.20139 5.67014 3.80556 5.83333 3.33333 5.83333ZM16.6667 5.83333C16.2083 5.83333 15.816 5.67014 15.4896 5.34375C15.1632 5.01736 15 4.625 15 4.16667C15 3.69444 15.1632 3.29861 15.4896 2.97917C15.816 2.65972 16.2083 2.5 16.6667 2.5C17.1389 2.5 17.5347 2.65972 17.8542 2.97917C18.1736 3.29861 18.3333 3.69444 18.3333 4.16667C18.3333 4.625 18.1736 5.01736 17.8542 5.34375C17.5347 5.67014 17.1389 5.83333 16.6667 5.83333ZM10 5C9.30556 5 8.71528 4.75694 8.22917 4.27083C7.74306 3.78472 7.5 3.19444 7.5 2.5C7.5 1.79167 7.74306 1.19792 8.22917 0.71875C8.71528 0.239583 9.30556 0 10 0C10.7083 0 11.3021 0.239583 11.7812 0.71875C12.2604 1.19792 12.5 1.79167 12.5 2.5C12.5 3.19444 12.2604 3.78472 11.7812 4.27083C11.3021 4.75694 10.7083 5 10 5ZM10 3.33333C10.2361 3.33333 10.434 3.25347 10.5938 3.09375C10.7535 2.93403 10.8333 2.73611 10.8333 2.5C10.8333 2.26389 10.7535 2.06597 10.5938 1.90625C10.434 1.74653 10.2361 1.66667 10 1.66667C9.76389 1.66667 9.56597 1.74653 9.40625 1.90625C9.24653 2.06597 9.16667 2.26389 9.16667 2.5C9.16667 2.73611 9.24653 2.93403 9.40625 3.09375C9.56597 3.25347 9.76389 3.33333 10 3.33333Z"
        fill="#ADAAAA"
      />
    </svg>
  );
}

/** 三级节点 icon（设计稿） */
function IconLevel3() {
  return (
    <svg className={styles.nodeSvg} width="19" height="14" viewBox="0 0 19 14" fill="none" aria-hidden>
      <path
        d="M0 13.3333V10C0 9.52778 0.163194 9.13194 0.489583 8.8125C0.815972 8.49306 1.20833 8.33333 1.66667 8.33333H4.39583C4.67361 8.33333 4.9375 8.40278 5.1875 8.54167C5.4375 8.68056 5.63889 8.86806 5.79167 9.10417C6.19444 9.64583 6.69097 10.0694 7.28125 10.375C7.87153 10.6806 8.5 10.8333 9.16667 10.8333C9.84722 10.8333 10.4826 10.6806 11.0729 10.375C11.6632 10.0694 12.1528 9.64583 12.5417 9.10417C12.7222 8.86806 12.934 8.68056 13.1771 8.54167C13.4201 8.40278 13.6736 8.33333 13.9375 8.33333H16.6667C17.1389 8.33333 17.5347 8.49306 17.8542 8.8125C18.1736 9.13194 18.3333 9.52778 18.3333 10V13.3333H12.5V11.4375C12.0139 11.7847 11.4896 12.0486 10.9271 12.2292C10.3646 12.4097 9.77778 12.5 9.16667 12.5C8.56944 12.5 7.98611 12.4062 7.41667 12.2188C6.84722 12.0312 6.31944 11.7639 5.83333 11.4167V13.3333H0ZM9.16667 10C8.63889 10 8.13889 9.87847 7.66667 9.63542C7.19444 9.39236 6.79861 9.05556 6.47917 8.625C6.24306 8.27778 5.94792 8.00347 5.59375 7.80208C5.23958 7.60069 4.85417 7.5 4.4375 7.5C4.74306 6.98611 5.38889 6.57986 6.375 6.28125C7.36111 5.98264 8.29167 5.83333 9.16667 5.83333C10.0417 5.83333 10.9722 5.98264 11.9583 6.28125C12.9444 6.57986 13.5903 6.98611 13.8958 7.5C13.4931 7.5 13.1111 7.60069 12.75 7.80208C12.3889 8.00347 12.0903 8.27778 11.8542 8.625C11.5486 9.06944 11.1597 9.40972 10.6875 9.64583C10.2153 9.88194 9.70833 10 9.16667 10ZM2.5 7.5C1.80556 7.5 1.21528 7.25694 0.729167 6.77083C0.243056 6.28472 0 5.69444 0 5C0 4.29167 0.243056 3.69792 0.729167 3.21875C1.21528 2.73958 1.80556 2.5 2.5 2.5C3.20833 2.5 3.80208 2.73958 4.28125 3.21875C4.76042 3.69792 5 4.29167 5 5C5 5.69444 4.76042 6.28472 4.28125 6.77083C3.80208 7.25694 3.20833 7.5 2.5 7.5ZM15.8333 7.5C15.1389 7.5 14.5486 7.25694 14.0625 6.77083C13.5764 6.28472 13.3333 5.69444 13.3333 5C13.3333 4.29167 13.5764 3.69792 14.0625 3.21875C14.5486 2.73958 15.1389 2.5 15.8333 2.5C16.5417 2.5 17.1354 2.73958 17.6146 3.21875C18.0938 3.69792 18.3333 4.29167 18.3333 5C18.3333 5.69444 18.0938 6.28472 17.6146 6.77083C17.1354 7.25694 16.5417 7.5 15.8333 7.5ZM9.16667 5C8.47222 5 7.88194 4.75694 7.39583 4.27083C6.90972 3.78472 6.66667 3.19444 6.66667 2.5C6.66667 1.79167 6.90972 1.19792 7.39583 0.71875C7.88194 0.239583 8.47222 0 9.16667 0C9.875 0 10.4688 0.239583 10.9479 0.71875C11.4271 1.19792 11.6667 1.79167 11.6667 2.5C11.6667 3.19444 11.4271 3.78472 10.9479 4.27083C10.4688 4.75694 9.875 5 9.16667 5Z"
        fill="#ADAAAA"
      />
    </svg>
  );
}

function NodeChip({ label, Icon, chipRef }) {
  return (
    <div ref={chipRef} className={styles.nodeChip}>
      <div className={styles.nodeIconWrap}>
        <Icon />
      </div>
      <span className={styles.nodeLabel}>{label}</span>
    </div>
  );
}

const LEVELS = [
  { key: "l1", labels: ["A1", "B1", "C1"], Icon: IconLevel1 },
  { key: "l2", labels: ["A21", "B21", "B22", "C2"], Icon: IconLevel2 },
  { key: "l3", labels: ["A31", "A32", "B31", "B32"], Icon: IconLevel3 },
];

function collectSegments(pt, connections) {
  /** @type {Segment[]} */
  const out = [];

  const single = (a, b) => {
    if (!a || !b) return;
    const dx = Math.abs(a.x - b.x);
    if (dx < 1.5) {
      out.push({ type: "v", x: a.x, y1: a.bottom, y2: b.top });
      return;
    }
    const span = b.top - a.bottom;
    const yMid = a.bottom + span * Math.min(0.55, Math.max(0.35, 28 / Math.max(span, 1)));
    out.push({ type: "v", x: a.x, y1: a.bottom, y2: yMid });
    out.push({ type: "h", x1: Math.min(a.x, b.x), x2: Math.max(a.x, b.x), y: yMid });
    out.push({ type: "v", x: b.x, y1: yMid, y2: b.top });
  };

  const fork = (pid, childIds) => {
    const p = pt(pid);
    const children = childIds.map((id) => pt(id)).filter(Boolean);
    if (!p || children.length < 2) return;
    const minChildTop = Math.min(...children.map((c) => c.top));
    const slot = minChildTop - p.bottom;
    if (slot < 2) return;
    const t = Math.min(0.5, Math.max(0.28, 36 / slot));
    const yJoin = p.bottom + slot * t;
    const xs = [p.x, ...children.map((c) => c.x)];
    const hLeft = Math.min(...xs);
    const hRight = Math.max(...xs);
    out.push({ type: "v", x: p.x, y1: p.bottom, y2: yJoin });
    out.push({ type: "h", x1: hLeft, x2: hRight, y: yJoin });
    children.forEach((c) => {
      out.push({ type: "v", x: c.x, y1: yJoin, y2: c.top });
    });
  };

  connections.forEach((c) => {
    if (c.t === "single") single(pt(c.a), pt(c.b));
    else if (c.t === "fork") fork(c.p, c.children);
  });

  return out;
}

function HierarchyConnectors({ width, height, segments }) {
  const uid = React.useId().replace(/[^a-zA-Z0-9_-]/g, "_");

  if (!segments.length || width < 1 || height < 1) return null;

  const verticals = segments.filter((s) => s.type === "v");

  return (
    <svg
      className={styles.connectorSvg}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <defs>
        {verticals.map((seg, i) => {
          const gid = `${uid}_gv_${i}`;
          return (
            <linearGradient
              key={gid}
              id={gid}
              gradientUnits="userSpaceOnUse"
              x1={seg.x}
              y1={seg.y1}
              x2={seg.x}
              y2={seg.y2}
            >
              <stop offset="0%" stopColor="#C1FF45" />
              <stop offset="100%" stopColor="rgba(193, 255, 69, 0)" />
            </linearGradient>
          );
        })}
      </defs>
      {segments.map((seg, i) => {
        if (seg.type === "v") {
          const vi = verticals.indexOf(seg);
          const gid = `${uid}_gv_${vi}`;
          return (
            <line
              key={`v-${seg.x}-${seg.y1}-${seg.y2}-${i}`}
              x1={seg.x}
              y1={seg.y1}
              x2={seg.x}
              y2={seg.y2}
              stroke={`url(#${gid})`}
              strokeWidth={1}
              vectorEffect="non-scaling-stroke"
            />
          );
        }
        return (
          <line
            key={`h-${seg.x1}-${seg.x2}-${seg.y}-${i}`}
            x1={seg.x1}
            y1={seg.y}
            x2={seg.x2}
            y2={seg.y}
            stroke="#C1FF45"
            strokeOpacity={0.75}
            strokeWidth={1}
            vectorEffect="non-scaling-stroke"
          />
        );
      })}
    </svg>
  );
}

function scheduleMeasure(fn) {
  requestAnimationFrame(() => {
    requestAnimationFrame(fn);
  });
}

export default function ReferralHierarchy() {
  const t = useTranslation();
  const treeWrapRef = useRef(null);
  const treeInnerRef = useRef(null);
  const nodeRefs = useRef({});
  const [connectorState, setConnectorState] = useState({ width: 0, height: 0, segments: [] });

  const chipRefFor = useCallback((id) => (el) => {
    if (el) nodeRefs.current[id] = el;
    else delete nodeRefs.current[id];
  }, []);

  const updateConnectors = useCallback(() => {
    const inner = treeInnerRef.current;
    if (!inner) return;
    const wr = inner.getBoundingClientRect();

    /** 连线：从 nodeLabel 下沿出发向下；从上方接入时接到 icon 上沿（视觉对齐树形） */
    const pt = (id) => {
      const chip = nodeRefs.current[id];
      if (!chip) return null;
      const labelEl = chip.querySelector(`.${styles.nodeLabel}`);
      const iconEl = chip.querySelector(`.${styles.nodeIconWrap}`);
      const chipR = chip.getBoundingClientRect();
      const labelR = labelEl?.getBoundingClientRect?.() ?? chipR;
      const iconR = iconEl?.getBoundingClientRect?.() ?? chipR;
      return {
        x: chipR.left + chipR.width / 2 - wr.left,
        top: iconR.top - wr.top,
        bottom: labelR.bottom - wr.top,
      };
    };

    const segs = collectSegments(pt, [
      { t: "single", a: "A1", b: "A21" },
      { t: "fork", p: "B1", children: ["B21", "B22"] },
      { t: "single", a: "C1", b: "C2" },
      { t: "fork", p: "A21", children: ["A31", "A32"] },
      { t: "fork", p: "B22", children: ["B31", "B32"] },
    ]);
    setConnectorState({
      width: inner.offsetWidth,
      height: inner.offsetHeight,
      segments: segs,
    });
  }, []);

  const runMeasure = useCallback(() => {
    scheduleMeasure(updateConnectors);
  }, [updateConnectors]);

  useLayoutEffect(() => {
    runMeasure();
    const inner = treeInnerRef.current;
    const wrap = treeWrapRef.current;
    if (!inner) return undefined;

    const ro = new ResizeObserver(() => runMeasure());
    ro.observe(inner);
    if (wrap) ro.observe(wrap);

    window.addEventListener("resize", runMeasure);
    const onScroll = () => runMeasure();
    if (wrap) wrap.addEventListener("scroll", onScroll, { passive: true });

    const t1 = window.setTimeout(runMeasure, 50);
    const t2 = window.setTimeout(runMeasure, 200);
    const t3 = window.setTimeout(runMeasure, 500);

    if (document.fonts?.ready) {
      document.fonts.ready.then(() => runMeasure());
    }

    return () => {
      ro.disconnect();
      window.removeEventListener("resize", runMeasure);
      if (wrap) wrap.removeEventListener("scroll", onScroll);
      window.clearTimeout(t1);
      window.clearTimeout(t2);
      window.clearTimeout(t3);
    };
  }, [runMeasure]);

  return (
    <div className={styles.hierarchy} dir="ltr">
      <div className={styles.hierarchyInner}>
        <div className={styles.youBlock}>
          <div className={styles.youAvatar}>
            <IconYou />
          </div>
          <span className={styles.youText}>{t("home.referralHierarchyYou")}</span>
        </div>

        <div className={styles.legendRow}>
          <div className={styles.legendItem}>
            <span className={styles.legendLabel}>{t("home.referralHierarchyRebate")}</span>
            <ArrowUpTriple className={styles.arrowSvg} />
          </div>
          <div className={styles.legendItem}>
            <ArrowDownTriple className={styles.arrowSvg} />
            <span className={styles.legendLabel}>{t("home.referralHierarchyInvite")}</span>
          </div>
        </div>

        <div className={styles.treeWrap} ref={treeWrapRef}>
          <div className={styles.treeInner} ref={treeInnerRef}>
            <HierarchyConnectors
              width={connectorState.width}
              height={connectorState.height}
              segments={connectorState.segments}
            />
            <div className={styles.treeLevels}>
              <div className={styles.levelRow}>
                <span className={styles.levelTag}>{t("home.referralHierarchyLevel1")}</span>
                <div className={styles.levelNodes}>
                  {LEVELS[0].labels.map((lb) => (
                    <NodeChip key={lb} label={lb} Icon={LEVELS[0].Icon} chipRef={chipRefFor(lb)} />
                  ))}
                </div>
              </div>

              <div className={styles.levelRow}>
                <span className={styles.levelTag}>{t("home.referralHierarchyLevel2")}</span>
                <div className={styles.levelNodes}>
                  {LEVELS[1].labels.map((lb) => (
                    <NodeChip key={lb} label={lb} Icon={LEVELS[1].Icon} chipRef={chipRefFor(lb)} />
                  ))}
                </div>
              </div>

              <div className={styles.levelRow}>
                <span className={styles.levelTag}>{t("home.referralHierarchyLevel3")}</span>
                <div className={styles.levelNodes}>
                  {LEVELS[2].labels.map((lb) => (
                    <NodeChip key={lb} label={lb} Icon={LEVELS[2].Icon} chipRef={chipRefFor(lb)} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
